// extracted by mini-css-extract-plugin
export default {"dropdown":"WarningsPopup_dropdown__tofhA","fadeMask":"WarningsPopup_fadeMask__eJwIA","warningsWrapper":"WarningsPopup_warningsWrapper__yF27J"};